/** 手机号码 */
export const mobileRegExp = /^1[3|4|5|6|7|8|9][0-9]\d{8}$/;

/** 电子邮箱 */
export const emailRegExp = /[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,3}$/i;
